import { gql } from 'apollo-boost';

// input DownloadFileInput {
//     fileName: String!
// }

export const DOWNLOAD_FILE = gql`
    query($data: DownloadFileInput!) {
        downloadFile(data: $data) {
            __typename
            ... on S3File {
                url
                cdn_url
            }
            ... on FileDoesNotBelongToUserError {
                message
            }
        }
    }
`;
